import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5percent from "@amcharts/amcharts5/percent";

export const addLicense = () => {
  am5.addLicense("AM5C328990290");
};

export const COLORS = {
  planning: am5.color("#ccad16"),
  design: am5.color("#ca7b04"),
  creator: am5.color("#ccad16"),
  open: am5.color("#87ad84"),
  promoter: am5.color("#87ad84"),
  closed: am5.color("#4a667c"),
  from_internal: am5.color("#9a9a9a"),
  from_external: am5.color("#4a667c"),
  not_completed: am5.color("#cc877d"),
  completed: am5.color("#9a9a9a"),
  adopter: am5.color("#498d7a"),
  user: am5.color("rgb(48,130,152)"),
  activated: am5.color("#4a667c"),
  registered: am5.color("#ca8a04"),
  churn: am5.color("#d06363"),
  pending: am5.color("#be9b53"),
  never_registered: am5.color("#4e555e"),
  leaving: am5.color("#4f5c70"),
};

export const lostWorksiteColors = {
  price: am5.color("#ccad16"),
  missing_in_geniuslab: am5.color("#ca7b04"),
  different_sell_channel: am5.color("#ca8a04"),
  material: am5.color("#87ad84"),
  difficult_to_apply: am5.color("#4a667c"),
  other_brand_fidelity: am5.color("#9a9a9a"),
  missing_certifications: am5.color("#4e555e"),
  other: am5.color("#498d7a"),
  not_specified: am5.color("#be9b53"),
  KKSolutionsOrProductsNotFound: am5.color("#d06363"),
  GLServiceNotFound: am5.color("#4f5c70"),
};

export const defaultDonutColors = [
  "rgb(0, 60, 80)",
  "rgb(8, 127, 140)",
  "rgb(90, 170, 149)",
  "rgb(134, 168, 115)",
  "rgb(152,151,102)",
  "rgb(187, 159, 6)",
  "rgb(222,164,54)",
  "rgb(234,151,59)",
  "rgb(234,120,59)",
  "rgb(206,96,76)",
  "rgb(238,130,168)",
  "rgb(232,131,219)",
  "rgb(166,101,183)",
  "rgb(109,97,150)",
  "rgb(80,103,121)",
  "rgb(67,80,107)",
  "rgb(89,97,115)",
  "rgb(132,222,2)",
  "rgb(171,39,79)",
  "rgb(196,98,16)",
];

export const setChartColor = (item) => {
  item.get("colors").set(
    "colors",
    defaultDonutColors.map((color) => am5.color(color))
  );
};

const defaultZoomSettings = {
  panX: true,
  panY: true,
  wheelX: "panX",
  wheelY: "zoomX",
};
export const getXYChart = (root, zoomSettings = defaultZoomSettings) => {
  let chart = root.container.children.push(
    am5xy.XYChart.new(root, zoomSettings)
  );

  setChartColor(chart);
  return chart;
};

export const getPieChart = (root, extraOptions = {}) => {
  return root.container.children.push(
    am5percent.PieChart.new(root, {
      layout: root.horizontalLayout,
      innerRadius: am5.percent(40),
      ...extraOptions,
    })
  );
};

export const getRenderAxisX = (root, grid = true) => {
  let xRenderer = am5xy.AxisRendererX.new(root, {});
  if (!grid) {
    xRenderer.grid.template.set("forceHidden", true);
  }
  xRenderer.labels.template.setAll({
    minPosition: 0.05,
    maxPosition: 0.95,
  });
  return xRenderer;
};

export const getRenderAxisY = (root, grid = true, inversed = false) => {
  let yRenderer = am5xy.AxisRendererY.new(root, {
    inversed: inversed,
    minGridDistance: 0,
  });
  if (!grid) {
    yRenderer.grid.template.set("forceHidden", true);
  }
  yRenderer.labels.template.setAll({
    minPosition: 0,
  });
  return yRenderer;
};

export const addCursor = (root, chart, x = true, y = false) => {
  let cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
  cursor.lineX.set("visible", x);
  cursor.lineY.set("visible", y);
};

export const getTooltip = (root, text) => {
  let tooltip = am5.Tooltip.new(root, {
    getFillFromSprite: true,
    autoTextColor: false,
    labelText: text,
  });

  tooltip.get("background").setAll({
    fill: am5.color("#afcdaf"),
    fillOpacity: 0.8,
  });

  tooltip.label.setAll({
    fill: am5.color("#1f1f1f"),
  });

  return tooltip;
};

export const addSeriesBullet = (root, series, radius = 4, strokeWidth = 2) => {
  series.bullets.push(function () {
    let circle = am5.Circle.new(root, {
      radius: radius,
      fill: series.get("fill"),
      stroke: root.interfaceColors.get("background"),
      strokeWidth: strokeWidth,
    });

    return am5.Bullet.new(root, {
      sprite: circle,
    });
  });
};
